import { CenterSpinner } from '@mr-yum/frontend-ui'
import { CartLayout, CartLayoutProps } from 'components/Cart/CartLayout'
import {
  CartLayoutBody,
  CartLayoutHeader,
  CartLayoutTitle,
} from 'components/Cart/shared'
import React, { PropsWithChildren } from 'react'

import { Text } from '../Skeleton/Text'

interface Props extends CartLayoutProps {
  header?: boolean
}

export const CartLayoutLoader = ({
  children,
  header = true,
  ...cartLayoutProps
}: PropsWithChildren<Props>) => (
  <CartLayout {...cartLayoutProps}>
    {header && (
      <CartLayoutHeader>
        <CartLayoutTitle>
          <Text chars={12} />
        </CartLayoutTitle>
      </CartLayoutHeader>
    )}

    {children || (
      <CartLayoutBody>
        <div className="mt-12">
          <CenterSpinner />
        </div>
      </CartLayoutBody>
    )}
  </CartLayout>
)
